import {
    AMEND_BOOKING,
    AMEND_BOOKING_FAILURE,
    AMEND_BOOKING_SUCCESS,
} from 'store/actions/types';

export const amendBooking = (payload) => {
    return {
        type: AMEND_BOOKING,
        payload: payload,
    };
};

export const amendBookingFailure = (error) => {
    return {
        type: AMEND_BOOKING_FAILURE,
        error: error,
    };
};

export const amendBookingSuccess = (id, response) => {
    return {
        type: AMEND_BOOKING_SUCCESS,
        id: id,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/bookings/amendBookings.js